import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { UncontrolledDropdown, DropdownToggle, DropdownMenu } from 'reactstrap'
import { gql, CombinedGraphQLErrors } from '@apollo/client'
import { useMutation } from '@apollo/client/react'
import { SET_USER_ATTRIBUTE_MUTATION } from '../../graphql'
import PaginationRecordMenuItem from './PaginationRecordMenuItem'
import {chooseUrl} from './PaginationUtils'
import './Pagination.css'

export const USER_ATTRIBUTE_MUTATION = gql(SET_USER_ATTRIBUTE_MUTATION)

export default function PaginationRecordMenu(props) {
  const { results, inputs, location } = props
  console.log('PaginationRecordMenu rendered:', props)
  const route = location.pathname.split('/')[1]
  
  let navigate = useNavigate()
  const [selection] = useState(results.recordsDisplayed)
  const [savedRecordsDisplayed] = useMutation(USER_ATTRIBUTE_MUTATION)

  async function recordMenuItemClicked(event, numberOfRecords) {
    console.log(numberOfRecords, 'record menu item clicked')
    await savedRecordsDisplayed({ variables: { attributeName: 'QUERY ROWS', attributeValue: `${numberOfRecords}` } })
      .then(() => {
        let start = results.start
        if (results.totalRecordsFound <= numberOfRecords) {
          start = 1
        }
        chooseUrl(start, route, results, inputs, navigate)
        window.location.reload()
      })
      .catch((error) => {
        if (CombinedGraphQLErrors.is(error)) {
          error.errors.map((error) => {
            return error.message
          })
        }
      })
  }

  const recordViewOptions = [10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 200, 300, 400, 500, 1000, 2500, 5000, 10000, 15000, 20000]
  const recordMenuItems = []
  recordViewOptions.forEach((item) => {
    recordMenuItems.push(<PaginationRecordMenuItem key={item} numberOfRecords={item} recordMenuItemClicked={recordMenuItemClicked} />)
  })
  let lastRecordNumber = results.start + results.recordsDisplayed - 1
  if (lastRecordNumber > results.totalRecordsFound) {
    lastRecordNumber = results.totalRecordsFound
  }

  // record count section
  let startEndText = ''
  if (results.totalRecordsFound > 0) {
    startEndText = `${results.start} - ${lastRecordNumber} of `
  }
  const recordCount =
    <div className="pagination-record-count-container">
      <span data-cy='pagination-record-number' className="pagination-record-number">{`${startEndText}${results.totalRecordsFound}`}</span> records found.
      <div style={{ display: 'inline-block', paddingLeft: '10px' }}>
        Show
        <UncontrolledDropdown className="pagination-record-menu-dropdown">
          <DropdownToggle className="btn-sm" data-cy='pagination-record-count-dropdown' caret >
            {selection}
          </DropdownToggle>
          <DropdownMenu className="pagination-record-menu">
            {recordMenuItems}
          </DropdownMenu>
        </UncontrolledDropdown>
        <span>records.</span>
      </div>
    </div>

  return recordCount
}